module.exports = __webpack_public_path__ + "static/2b-aca391806d8b6365a439e70fe2962b3a.webp";